import axios from './_nestAxios'

export const self = {
  aperturarTurno: data => axios.post('/turnos/self', data),
  cerrarTurno: data => axios.post('/turnos/self/cerrar', data),
  cambiarIsla: data => axios.put('/turnos/self/actualizar-isla', data)
}

export const obtenerxIdUsuarioAsSelect = idUsuario =>
  axios.get('/turnos', { params: { tipoConsulta: 'select-x-usuario', idUsuario: idUsuario } })

export const descargarTicketCierrexId = id =>
  axios.get(`/turnos/${id}/descargar/ticket-cierre`, { responseType: 'blob' })

export const descargarTicketCierrexIdAkdemic = id =>
  axios.get(`/turnos/${id}/descargar/ticket-cierre-akdemic`, { responseType: 'blob' })
  
export const obtenerReporteActualxFiltro = ({ self, id }) =>
  axios.get('/turnos/reporte-actual', { params: { self, id } })
